import React from "react";

import { IdNamePair } from "modules/common/models";
import SMSOptInDialog from "./smsOptInDialog";
import { Audience } from "modules/audiences";
import SMSOneLastCheck from "modules/sms/smsOneLastCheck";
import { messagingApi } from "api/instances";
import { Blast, EventAttemptModel, NotificationEvents } from "modules/messaging";
import { DEFAULT_SMS } from "modules/sms/reducer";
import { ISMSPreviewDetails } from "modules/sms/models";
import { smsBodiesResource, SMSMappings } from "modules/resources";
import { eventUppercase } from "utils/notificationsHelper";

interface ISMSSendInvitesProps {
    audiences: Audience[];
    optInOpen: boolean;
    lastCheckOpen: boolean;
    defaultLCID: string;
    smsBodies: smsBodiesResource;
    setOptInOpen: (open: boolean) => void;
    setLastCheckOpen: (open: boolean) => void;
    optInTranslation: EventAttemptModel;
    setSuccessMessage: (message: string) => void;
    setErrorMessage: (message: string) => void;
}

const SMSSendInvites: React.FC<ISMSSendInvitesProps> = ({
    audiences,
    defaultLCID,
    optInOpen,
    smsBodies,
    setOptInOpen,
    lastCheckOpen,
    setLastCheckOpen,
    optInTranslation,
    setSuccessMessage,
    setErrorMessage
}) => {
    const [sendInviteAudiences, setSendInviteAudiences] = React.useState<IdNamePair<string, string>[]>([]);
    const [audienceUsers, setAudienceUsers] = React.useState(0);
    const [totalUsers, setTotalUsers] = React.useState(0);
    const [selectAllUsers, setSelectAllUsers] = React.useState(false);

    const swapToLastCheck = () => {
        setOptInOpen(false);
        setLastCheckOpen(true);
    }

    const onSendSMS = async() => {
        var textToUse:SMSMappings = {[defaultLCID]: getTextForMessage()};

        const blast:Blast = {
            audienceIds: sendInviteAudiences.map(a => a.id),
            translatedBody: textToUse,
            sendToAllUsers: selectAllUsers
        }

        try {
            await messagingApi.MassSendConsent(blast);
            setSuccessMessage("Successfully sent your SMS opt-in invite.");
        }
        catch {
            setErrorMessage("Something went wrong, please try again later.")
        }
        finally {
            setLastCheckOpen(false);
        }
    }

    const fetchSendDetails = (): ISMSPreviewDetails => {
        return {
            title: undefined,
            sentTime: undefined,
            sendToAllUsers: selectAllUsers,
            audiences: sendInviteAudiences,
            textBody: getTextForMessage(),
            fromNumber: DEFAULT_SMS.fromNumber ?? ""
        }
    }

    const getTextForMessage = () => {
        const hasCustomText = !!optInTranslation.translatedBody[defaultLCID] && optInTranslation.translatedBody[defaultLCID] !== "";

        return hasCustomText ? optInTranslation.translatedBody[defaultLCID] : smsBodies[eventUppercase(NotificationEvents.VerifySMSPhone)].toString();
    }

    return (
        <React.Fragment>
            <SMSOptInDialog 
                open={optInOpen}
                onClose={() => setOptInOpen(false)}
                audiences={audiences}
                selectedAudiences={sendInviteAudiences}
                setSelectedAudiences={setSendInviteAudiences}
                onNext={swapToLastCheck}
                audienceUsers={audienceUsers}
                setAudienceUsers={setAudienceUsers}
                totalUsers={totalUsers}
                setTotalUsers={setTotalUsers}
                selectAllUsers={selectAllUsers}
                setSelectAllUsers={setSelectAllUsers}
            />

            <SMSOneLastCheck 
                show={lastCheckOpen}
                totalAudienceUsers={totalUsers}
                audienceUsers={audienceUsers}
                onClose={() => setLastCheckOpen(false)}
                sendSMS={() => onSendSMS()}
                sending={false}
                downloadOptedInUsers={false}
                smsDetails={fetchSendDetails()}
                hideSentTime
                showDisclaimer
            />
        </React.Fragment>
    )
}

export default(SMSSendInvites);